import { lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';

import { ProposalLayout } from '../layouts/proposal-layout';
import { RedirectToPublicProposal } from '../redirect-to-public-proposal';
import { RedirectToPublicProposalWhenPrinting } from '../redirect-to-public-proposal-when-printing';
import { GD_SIMULATOR_PATH, GD_PROPOSAL_FORM_PATH } from '../constants';

const GdHistoryPage = lazy(() => import('@pages/gd/history'));
const GdSimulatorPage = lazy(() => import('@pages/gd/simulator'));
const GdProposalPage = lazy(() => import('@pages/gd/proposal'));
const GdProposalFormPage = lazy(() => import('@pages/gd/proposal/components/gd-proposal-form'));

export const getGdRoutes = () => [
  <Route key="gd-simulator" path={GD_SIMULATOR_PATH}>
    <Route
      index
      element={
        <Suspense fallback={null}>
          <GdHistoryPage />
        </Suspense>
      }
    />
    <Route
      path="novo"
      element={
        <Suspense fallback={null}>
          <GdSimulatorPage />
        </Suspense>
      }
    />
    <Route
      path={GD_PROPOSAL_FORM_PATH}
      element={
        <Suspense fallback={null}>
          <GdProposalFormPage />
        </Suspense>
      }
    />
  </Route>,
];

export const getGdPublicRoutes = () => [
  <Route
    key="gd-proposal"
    path={`${GD_SIMULATOR_PATH}/proposta/:id`}
    element={
      <RedirectToPublicProposalWhenPrinting>
        <ProposalLayout>
          <Suspense fallback={null}>
            <GdProposalPage />
          </Suspense>
        </ProposalLayout>
      </RedirectToPublicProposalWhenPrinting>
    }
  />,
  <Route
    key="gd-proposal-document"
    path={`${GD_SIMULATOR_PATH}/proposta/:id/documento`}
    element={<RedirectToPublicProposal />}
  />,
];
